import { SubmissionMethod, SubmissionType } from "generated-graphql/graphql";

/**
 * Type guards for narrowing a raw `string` (e.g. a MUI Select `onChange` value
 * or a URL search param) to a `SubmissionType` / `SubmissionMethod` without an
 * `as` cast. The values are validated against the enum's own members.
 */
export function isSubmissionType(value: string): value is SubmissionType {
  return (Object.values(SubmissionType) as string[]).includes(value);
}

export function isSubmissionMethod(value: string): value is SubmissionMethod {
  return (Object.values(SubmissionMethod) as string[]).includes(value);
}
